import { render, staticRenderFns } from "./FormFieldReadonly.vue?vue&type=template&id=672c38c8&scoped=true"
import script from "./FormFieldReadonly.vue?vue&type=script&lang=js"
export * from "./FormFieldReadonly.vue?vue&type=script&lang=js"
import style0 from "./FormFieldReadonly.vue?vue&type=style&index=0&id=672c38c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c38c8",
  null
  
)

export default component.exports